@if (dev) {
  <div class="devenv">QA ENVIRONMENT</div>
}
<router-outlet />
@if (isSpinnerVisible) {
  <mat-progress-bar
    class="loader"
    mode="indeterminate"
    value="40"></mat-progress-bar>
}
